<div class="documento-aditivo-container espacamento-mobile rodape-sem-quebra" style="margin-top: -57px !important">
  <h3 class="titulo text-center bold-preto-700" style="background: #ccc; border-radius: 10px">
    Carta de Orientação ao Beneficiário
  </h3>
  <p>Prezado(a) Beneficiário(a),</p>
  <p class="mb-1 text-justify">
    A Agência Nacional de Saúde Suplementar (ANS), instituição que regula as atividades das operadoras de planos
    privados de assistência à saúde, e tem como missão defender o interesse público vem, por meio desta, prestar
    informações para o preenchimento da DECLARAÇÃO DE SAÚDE.
  </p>
  <h4 class="subtitulo">O QUE É DECLARAÇÃO DE SAÚDE?</h4>
  <p class="mb-1 text-justify">
    É o formulário que acompanha o Contrato do Plano de Saúde, onde o beneficiário ou seu representante legal deverá
    informar doenças ou lesões preexistentes que saiba ser portador ou sofredor no momento da contratação do plano. Para
    o seu preenchimento, o beneficiário tem o direito de ser orientado, gratuitamente, por um médico
    credenciado/referenciado pela operadora. Se optar por um profissional de sua livre escolha, assumirá o custo desta
    opção. Portanto, se o beneficiário (você) toma medicamentos regularmente, consulta médicos por problema de saúde do
    qual conhece o diagnóstico, fez qualquer exame que identificou alguma doença ou lesão, esteve internado ou
    submeteu-se a alguma cirurgia, DEVE DECLARAR ESTA DOENÇA OU LESÃO.
  </p>
  <!-- <p class="mb-1 text-justify">

  </p> -->
  <h4 class="subtitulo">
    AO DECLARAR AS DOENÇAS E/ OU LESÕES QUE O BENECIFIÁRIO SAIBA SER PORTADOR NO MOMENTO DA CONTRATAÇÃO.
  </h4>
  <ul class="alinhamento-texto-mobile">
    <li>
      <p class=" ">
        * A operadora NÃO poderá impedi-lo de contratar o plano de saúde. Caso isto ocorra, encaminhe a denúncia à ANS.
      </p>
    </li>
    <li>
      <p class=" ">
        * A operadora deverá oferecer: cobertura total ou COBERTURA PARCIAL TEMPORÁRIA (CPT), podendo ainda oferecer o
        Agravo, que é um acréscimo no valor da mensalidade, pago ao plano privado de assistência à saúde, para que possa
        utilizar toda a cobertura contratada, após os prazos de carências contratuais.
      </p>
    </li>
    <li>
      <p class=" ">
        * No caso de CPT, haverá restrição de cobertura para cirurgias, leitos de alta tecnologia (UTI, unidade
        coronáriana ou neonatal), e procedimentos de alta complexidade -PAC (tomografia, ressonância, etc.*),
        EXCLUSIVAMENTE relacionados à doença ou lesão declarada, até 24 meses, contados desde a assinatura do contrato.
        Após o período máximo de 24 meses da assinatura contratual, a cobertura passará a ser integral, de acordo com o
        plano contratado.
      </p>
    </li>
    <li>
      <p class=" ">
        * NÃO haverá restrição de cobertura para consultas médicas, internações não cirúrgicas, exames e procedimentos
        que não sejam de alta complexidade, mesmo que relacionados à doença ou lesão preexistente declarada, desde que
        cumpridos os prazos de carências estabelecidas no contrato.
      </p>
    </li>
    <li>
      <p class=" ">
        *Não caberá alegação posterior de omissão de informação na Declaração de Saúde por parte da operadora para esta
        doença ou lesão.
      </p>
    </li>
  </ul>
  <h4 class="subtitulo">
    AO NÃO DECLARAR AS DOENÇAS E/ OU LESÕES QUE O BENEFICIÁRIO SAIBA SER PORTADOR NO MOMENTO DA CONTRATAÇÃO:
  </h4>

  <ul class="alinhamento-texto-mobile">
    <li>
      <p class=" ">
        * A operadora poderá suspeitar de omissão de informação e, neste caso, deverá comunicar imediatamente ao
        beneficiário, podendo oferecer CPT, ou solicitar abertura de processo administrativo junto à ANS, denunciando a
        omissão da informação.
      </p>
    </li>
    <li>
      <p class=" ">
        * Comprovada a omissão de informação pelo beneficiário, a operadora poderá RESCINDIR o contrato por FRAUDE e
        responsabilizá-lo pelos procedimentos referentes à doença ou lesão não declarada.
      </p>
    </li>
    <li>
      <p class=" ">
        * Até o julgamento final do processo pela ANS, NÃO poderá ocorrer suspensão do atendimento nem rescisão do
        contrato. Caso isto ocorra, encaminhe a denúncia à ANS.
      </p>
    </li>
    <li>
      <p class=" " style="font-size: 11px !important; font-weight: 500 !important">
        ATENÇÃO! Se a operadora oferecer redução ou isenção de carência, isto não significa que dará cobertura
        assistencial para as doenças ou lesões que o beneficiário saiba ter no momento da assinatura contratual.
        Cobertura Parcial Temporária - CPT - NÃO É CARÊNCIA! Portanto, o beneficiário não deve deixar de informar se
        possui alguma doença ou lesão, ao preencher a Declaração de Saúde!
      </p>
    </li>
  </ul>
  <p class="alinhamento-texto-mobile"></p>
</div>
<div class="mt-1">
  <app-assinatura-documento
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaCartaOrientacaoDS"
    [horaAssinatura]="horaAssinaturaCartaOrientacaoDS"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</div>
